import React, { Component } from 'react';
import {Container,Row,Col,Image} from 'react-bootstrap';
import {
  Link
} from "react-router-dom";

/* Imagenes nuevas */
import bodaLogo from '../../Resources/Images/imagenBodas.jpg'
import regalosLogo from '../../Resources/Images/imagenRegalos.jpg'

import SvContent from './SvContent';
import GtContent from './GtContent';
import NiContent from './NiContent';
import CrContent from './CrContent';

class MainPage extends Component{
  //Heredar estados globales  
  constructor(props){
    super(props)
    this.state = {
      varPais: this.props.varPais,
      eventos: this.props.eventos,
      busqueda: ''
    };

    this.setEvento = this.setEvento.bind(this);
    this.paisContent = this.paisContent.bind(this);
  }

  setEvento(e) {
    this.setState({
      busqueda: e.target.value
    })
  }

  handleKey(e) {
    if(e.keyCode === 13){
      document.getElementById("linkToSearch").click()
    }
  }

  render (){

    const  { varPais } = this.props;

    return (
      
      <div className="clubes-row">
      <Row className="clubes--mobile-style pt-3 pb-3 clubes--sticky-top">
        <div className="mx-auto">
              
          <div className="d-flex justify-content-center clubes--search-container">
            <input id="busqueda" type="text" placeholder="Buscar por id del evento" className="clubes--search" name="busqueda" onChange={this.setEvento} onKeyDown={this.handleKey}/>
            <Link id="linkToSearch" to={{pathname: varPais+'Search', state: {busqueda: this.state.busqueda}}} className="clubes--icon-search" ></Link>
          </div>
              
        </div>
      </Row>
      <Container>
        

        {/** Los dos accesos a boda y a regalos */}
        <Row className="justify-content-md-center">
          
          <Col sm={6} className="d-flex flex-column align-items-center justify-content-center">
            <div className="cont">
              <Link to={ { pathname: varPais+'eventos-bodas', state:  varPais }}>
                <Image className="mt-2 mb-2" src={bodaLogo} fluid/>
              </Link>
            </div>
            {/*this.paisBottomBodas(this.state.varPais)*/}
          </Col>
          
          <Col sm={6} className="d-flex flex-column align-items-center justify-content-center">
            <div className="cont">
              <Link to={ { pathname:  varPais+'eventos-regalos', state:  varPais} } >
                <Image className="mt-2 mb-2" src={regalosLogo} fluid/>
              </Link>
            </div>
            {/*this.paisBottomRegalos(this.state.varPais)*/}
          </Col>
        
        </Row>
        
        {
          this.paisContent(varPais)
        }
      
      </Container>

      </div>
    );  
  }


  paisContent(pais){
    switch(pais) {
      case '/SV/':
        return (
          <SvContent></SvContent>
        )
      case '/GT/':
        return (
          <GtContent></GtContent> 
        )
      case '/CR/':
        return (
          <CrContent></CrContent>
        )
      case '/NI/':
        return (
          <NiContent></NiContent>
        )
      default:
        return (
          null 
        )
    }
  }

}

export default MainPage;